import React, { ReactNode, useEffect, useState } from 'react'

import LoginModal, { limitTypeType } from '../components/signup/login/LoginModal/LoginModal'
import { getLimitTypeLabelToLimit, LimitTypesLabel } from '../utils/limits'
import { useInternationalization } from './InternationalizationContext'

type FetchType = {
  // Login
  loginOpen: boolean
  setLoginOpen: (a?: boolean) => void
  loginLimitName: LimitTypesLabel | undefined
  setLoginLimitName: (a: LimitTypesLabel | undefined) => void
  loginLimitType: limitTypeType
  setLoginLimitType: (a: limitTypeType) => void
}

export const CommonModalsLightContext = React.createContext<FetchType>({
  loginOpen: false,
  setLoginOpen: () => {},
  loginLimitName: undefined,
  setLoginLimitName: () => {},
  loginLimitType: undefined,
  setLoginLimitType: () => {},
})

export const CommonModalsLightProvider = ({ children }: { children: ReactNode }) => {
  const { addComponentText } = useInternationalization()

  // Login
  const [loginOpen, setLoginOpen] = useState(false)
  const [loginLimitName, setLoginLimitName] = useState<LimitTypesLabel | undefined>(undefined)
  const [loginLimitType, setLoginLimitType] = useState<limitTypeType>(undefined)

  useEffect(() => {
    addComponentText('CommonModalsContext')
  }, [])

  return (
    <CommonModalsLightContext.Provider
      value={{
        loginOpen,
        setLoginOpen: (val) => setLoginOpen(!!val),
        loginLimitName,
        setLoginLimitName,
        loginLimitType,
        setLoginLimitType,
      }}
    >
      <LoginModal
        opened={loginOpen}
        onClose={() => {
          setLoginOpen(false)
          setTimeout(() => {
            setLoginLimitName(undefined)
            setLoginLimitType(undefined)
          }, 300)
        }}
        limitName={loginLimitName && getLimitTypeLabelToLimit(loginLimitName)}
        limitType={loginLimitType}
      />
      {children}
    </CommonModalsLightContext.Provider>
  )
}

export const useCommonModalsLight = () => React.useContext<FetchType>(CommonModalsLightContext)
